// extracted by mini-css-extract-plugin
export default {"content":"change-pool-confirmation_content__uGz6y"};